import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../../utils/menu";

const It = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[2].title)} menuList={menuList[2].list} backgroundImage="/imgs/bg_globalit" />
      <div className="it_wrap" style={{ maxWidth: "1920px", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Outlet />
      </div>
    </>
  );
};

export default It;
